import { render, staticRenderFns } from "./CaptchaNotice.vue?vue&type=template&id=01ae58d3&scoped=true&"
import script from "./CaptchaNotice.vue?vue&type=script&lang=js&"
export * from "./CaptchaNotice.vue?vue&type=script&lang=js&"
import style0 from "./CaptchaNotice.vue?vue&type=style&index=0&id=01ae58d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ae58d3",
  null
  
)

export default component.exports